import { useContext, useEffect } from "react"
import _ from "lodash"
import { Field } from "formik"
import { FormContext } from "../../context/formContext"

import { Dropdown } from "primereact/dropdown"
import styles from "../../styles/Form.module.css"

import fieldVisibility from "../../helpers/fieldVisibility"

export default function TypeDropdownGrouped({ field, block, index }) {
  const form = useContext(FormContext)
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()
  const { field_options } = field
  const grouping = _.map(field_options, (field_option) => {
    const option = _.split(field_option.value, "|")
    return { groupName: _.trim(option[0]), groupItem: _.trim(option[1]) }
  })
  const groups = _.chain(grouping)
    .groupBy("groupName")
    .map((groupName, groupItem) => ({ [groupItem]: groupName }))
    .value()
  const groupOptions = _.assign({}, ...groups)
  const optionList = _.map(groupOptions, (group, key) => {
    const options = _.map(group, (item) => {
      return {
        label: _.trim(item.groupItem),
        value: `${key} | ${item.groupItem}`,
      }
    })
    return {
      label: key,
      code: key,
      items: options,
    }
  })
  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: fieldVisibility(field.field_visibility),
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={field.field_name}>
          {({ field: formikField, meta }) => (
            <>
              <Dropdown
                placeholder="Please select"
                id={field.field_name}
                name={formikField.name}
                value={formikField.value}
                onChange={formikField.onChange}
                disabled={isDisabled}
                options={optionList}
                optionGroupLabel="label"
                optionGroupChildren="items"
              />
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )}
        </Field>
      </div>
    </div>
  )
}
